import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchEmployerPageContent } from "../../../redux/actions/company_action";
import {
    DefaultLogo,
    HoverLogo,
    LogoLink,
    LogoRow,
    SectionFrame,
    Title,
} from "./styles";

const query = `
    featuredMedia {
        defaultLogo_Greyed {
            data {
                attributes {
                    url
                }
            }
        }
        hoverLogo_Colored {
            data {
                attributes {
                    url
                }
            }
        }
        mediaPlatform
        urlLinks
    }
`;

export default function EmployerFeaturedMedia() {
    const dispatch = useDispatch();
    const [featuredMedia, setFeaturedMedia] = useState([]);

    async function fetchData() {
        const response = await dispatch(fetchEmployerPageContent(query));
        setFeaturedMedia(response?.featuredMedia || []);        
    }

    useEffect(() => {
        fetchData();
    }, []);

    const title = featuredMedia?.[0]?.title || "see our latest media features";

    const logos = featuredMedia || [];

    return (
        <SectionFrame>
            <Title>
                {title}
            </Title>

            <LogoRow>
                {logos.map((item, index) => {
                    const defaultLogo = 
                        item?.defaultLogo_Greyed?.data?.attributes?.url;
                    const hoverLogo = 
                        item?.hoverLogo_Colored?.data?.attributes?.url;

                    return (
                        <LogoLink
                            key={index}
                            href={item?.urlLinks}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <DefaultLogo
                                className="default-logo"
                                src={defaultLogo}
                                alt="media feature logo"
                            />
                            <HoverLogo
                                className="hover-logo"
                                src={hoverLogo}
                                alt="media feature logo"
                            />
                        </LogoLink>
                    );
                })}
            </LogoRow>
        </SectionFrame>
    );
}